const FIXED_TIME = 15
export default {
  data() {
    return {
      // 导出参数配置:
      exportZipObj: {
        contextMenuWrap: [],
        sortProp: '',
        sortOrder: ''
      },
      computedTime: FIXED_TIME
    }
  },
  methods: {
    batchExportZip(listName) {
      let tableQuery = listName['tableQuery']
      for (let key in tableQuery) {
        this.exportZipObj[key] = tableQuery[key]
      }
      if (this.computedTime === FIXED_TIME) {
        this.setExportZipByPage()
        this.$message({
          dangerouslyUseHTMLString: true,
          type: 'success',
          message: `<strong>系统后台正在努力导出中...</strong>`,
          duration: 5000,
          offset: 80
        })
      } else {
        this.$message({ message: '您的操作过于频繁，请稍后再试！', type: 'warning' })
      }
    },
    setExportZipByPage() {
      this.exportZipByPage()
      this.timer = setInterval(() => {
        this.computedTime--
        if (this.computedTime === 0) {
          clearInterval(this.timer)
          this.computedTime = FIXED_TIME
        }
      }, 1000)
    }
  }
}
